import { MdOutlineEdit } from 'react-icons/md';
import { TmdxUser } from '@ui';
import { IconButton, StarRating, Card, CardBody, CardFooter, CardHeader } from '@ds';
import { MultiSuggestEmployeeRoleList } from '@lp/features/MultiSuggest';
import { formatSuggestionDate } from '@lp/features/MultiSuggest/utils';
import { SuggestionReviewType } from '@/api/apis/multi-suggest';

type MultiSuggestReviewProps = {
  data: SuggestionReviewType;
  isReadOnly: boolean;
  onEdit?: (review: SuggestionReviewType) => void;
};

export const MultiSuggestReview = ({ data, isReadOnly = false, onEdit }: MultiSuggestReviewProps) => {
  return (
    <Card
      classNames={{
        base: 'flex-1/5 bg-base-90 rounded-2xl shadow-none max-w-93.5',
        header: 'flex shrink-0 justify-between items-center pb-0',
        body: 'grow text-m-m text-base-5 text-ellipsis break-all max-h-40 overflow-y-auto py-2.5',
        footer: 'flex flex-col gap-2.5 items-start pt-0',
      }}
    >
      <CardHeader>
        <StarRating value={data.rating} readOnly showValue />
        {!isReadOnly && (
          <IconButton
            size="xs-s"
            variant="action"
            className="text-base-5"
            startContent={<MdOutlineEdit size={20} />}
            onPress={() => onEdit?.(data)}
          />
        )}
      </CardHeader>
      <CardBody>{data.comment}</CardBody>
      <CardFooter>
        <span className="text-s-r text-base-20">{formatSuggestionDate(data.createdAt)}</span>
        <TmdxUser
          avatarProps={{
            size: 'md',
            radius: 'md',
            src: data.user.photo,
            name: data.user.fullName,
          }}
          title={data.user.fullName}
          titleSize="md"
          titleColor="black"
          itemsAlignment="start"
        >
          <MultiSuggestEmployeeRoleList roles={data.user.roles} />
        </TmdxUser>
      </CardFooter>
    </Card>
  );
};
